import { useEffect, useState } from "react";

const NAV_LINKS = [
  { label: "按场景切片", href: "#scene" },
  { label: "大图卡片流", href: "#stream" },
  { label: "热场弹幕", href: "#buzz" },
  { label: "今日热榜", href: "#rank" },
  { label: "怎么找", href: "#howto" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="sticky top-0 z-50 w-full">
      {/* 顶部运营工具条 */}
      <div className="bg-foreground-950 text-background-100">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-2 md:px-6">
          <p className="hidden items-center gap-2 text-xs text-background-100/80 sm:flex">
            <i className="ri-flashlight-fill text-accent-400" />
            打开就能看 · 免登录 · 全部按场景切好片
          </p>
          <div className="flex items-center gap-1 text-xs text-background-100/80 sm:gap-2">
            <a href="#stream" className="rounded-md px-2 py-1 transition hover:text-background-50">只看动图</a>
            <span className="text-background-100/30">/</span>
            <a href="#stream" className="rounded-md px-2 py-1 transition hover:text-background-50">只看录屏</a>
            <span className="text-background-100/30">/</span>
            <a href="#buzz" className="rounded-md px-2 py-1 transition hover:text-background-50">去评论区</a>
          </div>
        </div>
      </div>

      {/* 主导航 */}
      <div
        className={`border-b transition-colors duration-300 ${
          scrolled
            ? "border-background-200 bg-background-50/90 backdrop-blur"
            : "border-transparent bg-background-50"
        }`}
      >
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 md:px-6">
          <a href="#top" className="group flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-play-list-fill text-lg" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-black tracking-tight text-foreground-950">
                黑料色
              </span>
              <span className="mt-1 text-[11px] tracking-wide text-foreground-500">按场景切片的资源站</span>
            </span>
          </a>

          <nav className="hidden items-center gap-1 md:flex">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition hover:bg-background-100 hover:text-primary-700"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#howto"
              className="ml-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition hover:bg-primary-600"
            >
              开始翻片
            </a>
          </nav>

          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开导航"
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-800 md:hidden"
          >
            <i className={`ri-${open ? "close" : "menu"}-line text-lg`} />
          </button>
        </div>

        {open && (
          <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
            <div className="flex flex-col gap-1">
              {NAV_LINKS.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="rounded-md px-3 py-2 text-sm text-foreground-800 hover:bg-background-100"
                >
                  {l.label}
                </a>
              ))}
            </div>
          </div>
        )}
      </div>
    </header>
  );
}